<template>
  <div class="w-full py-6">
    <h1 class="text-2xl font-semibold text-gray-800 mb-2">Video tutoriales</h1>
    <p class="text-gray-600 mb-6">
      Selecciona un tema para ver el video correspondiente.
    </p>

    <div class="space-y-3">
      <div
        v-for="(video, index) in videos"
        :key="video.file"
        class="bg-white rounded-lg shadow-sm border border-gray-200"
      >
        <button
          class="w-full flex items-center justify-between px-4 py-3 text-left"
          type="button"
          @click="toggleAccordion(index)"
        >
          <span class="font-medium text-gray-800">{{ video.title }}</span>
          <i
            class="fa-solid fa-chevron-down transition-transform duration-200"
            :class="{ 'rotate-180': openedIndex === index }"
          />
        </button>

        <div v-if="openedIndex === index" class="px-4 pb-4">
          <p class="text-sm text-gray-600 mb-3">{{ video.description }}</p>
          <button
            class="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
            type="button"
            @click="openVideo(video)"
          >
            Reproducir video
          </button>
        </div>
      </div>
    </div>

    <div
      v-if="isModalOpen"
      class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70 px-4"
      @click.self="closeModal"
    >
      <div class="bg-white rounded-lg shadow-xl w-full max-w-4xl">
        <div class="flex items-center justify-between px-4 py-3 border-b border-gray-200">
          <h2 class="text-lg font-semibold text-gray-800">{{ selectedVideo?.title }}</h2>
          <button
            class="text-gray-500 hover:text-gray-700"
            type="button"
            @click="closeModal"
          >
            <i class="fa-solid fa-xmark text-xl" />
          </button>
        </div>

        <div class="p-4">
          <video
            v-if="selectedVideo"
            class="w-full rounded"
            controls
            autoplay
            :src="selectedVideo.url"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VideoTutorialsView',
  data() {
    return {
      openedIndex: null,
      isModalOpen: false,
      selectedVideo: null,
      videos: [
        {
          title: 'Validar datos',
          description: 'Tutorial sobre validacion de datos.',
          slug: 'validar-datos',
          file: 'validar-datos.mp4',
          url: '/video-tutorials-files/validar-datos.mp4',
        },
        {
          title: 'Solicitud de concepto profesional',
          description: 'Explicacion del concepto profesional.',
          slug: 'solicitud-de-concepto-profesional',
          file: 'solicitud-de-concepto-profesional.mp4',
          url: '/video-tutorials-files/solicitud-de-concepto-profesional.mp4',
        },
        {
          title: 'Descarga de concepto profesional',
          description: 'Tutorial para descargar concepto profesional.',
          slug: 'descarga-concepto-profesional',
          file: 'descarga-concepto-profesional.mp4',
          url: '/video-tutorials-files/descarga-concepto-profesional.mp4',
        },
      ],
    };
  },
  mounted() {
    this.openVideoFromRoute();
  },
  watch: {
    '$route.params.videoSlug'() {
      this.openVideoFromRoute();
    },
  },
  methods: {
    toggleAccordion(index) {
      this.openedIndex = this.openedIndex === index ? null : index;
    },
    openVideo(video) {
      if (this.$route.params.videoSlug !== video.slug) {
        this.$router.push(`/video-tutorials/${video.slug}`);
      }

      this.selectedVideo = video;
      this.isModalOpen = true;
    },
    closeModal() {
      this.isModalOpen = false;
      this.selectedVideo = null;

      if (this.$route.params.videoSlug) {
        this.$router.push('/video-tutorials');
      }
    },
    openVideoFromRoute() {
      const { videoSlug } = this.$route.params;

      if (!videoSlug) {
        this.isModalOpen = false;
        this.selectedVideo = null;
        return;
      }

      const video = this.videos.find((item) => item.slug === videoSlug);

      if (!video) {
        this.$router.replace('/video-tutorials');
        return;
      }

      this.openedIndex = this.videos.findIndex((item) => item.slug === videoSlug);
      this.selectedVideo = video;
      this.isModalOpen = true;
    },
  },
};
</script>
